import { render, staticRenderFns } from "./instructions_header_image.vue?vue&type=template&id=2d85a97b&scoped=true&"
import script from "./instructions_header_image.vue?vue&type=script&lang=js&"
export * from "./instructions_header_image.vue?vue&type=script&lang=js&"
import style0 from "./instructions_header_image.vue?vue&type=style&index=0&id=2d85a97b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d85a97b",
  null
  
)

export default component.exports